import {Component, OnInit} from '@angular/core';
import {ReportInfoDTO} from '../../../model/reportInfoDTO';
import {ReportComponent} from '../../report/report.component';
import {BreadcrumbComponent} from '../../breadcrumb/breadcrumb.component';
import {ActivatedRoute, Router} from '@angular/router';
import {ShouldPreviewService} from '../../../services/should-preview-service';
import {ReportService} from '../../../services/report.service';

@Component({
  templateUrl: './payment-failed.component.html',
})
export class PaymentFailedComponent implements OnInit {

  reportInfo: ReportInfoDTO;

  constructor(private route: ActivatedRoute,
              private shouldPreviewService: ShouldPreviewService,
              private router: Router,
              public reportService: ReportService) {
  }

  ngOnInit(): void {
    this.route.params.subscribe(params => this.getReportInfo(params['reportId']));
  }

  private getReportInfo(reportId: number) {
    this.reportService.getInfo(reportId).subscribe(reportInfo => this.reportInfo = reportInfo);
  }

  toReport() {
    const {clientId, type, year} = this.reportInfo;
    this.router.navigate(this.reportService.getReportUrl(clientId, type, year));
  }
}
